export const allRoles = [
  {
    'name': 'SStudio',
    'parent': 'SSENSE',
    'resources': []
  },
  {
    'name': 'Manager',
    'parent': 'SStudio',
    'resources': [
      'bookings:read',
      'bookings:write',
      'bookings:fast-track',
      'employees:read',
      'employees:write',
      'studio-models:read',
      'entities:read',
      'entities:write',
      'employees-rates:read',
      'my-rates:read',
      'my-availabilities:write',
      'activities:read',
      'activities:write',
      'callsheets:read',
      'callsheets:send',
      'my-profile:read',
      'dashboard:read',
      'last-minute-availabilities:write',
      'po-pre-approved:read',
      'po-pre-approved:write',
      'reporting:read',
    ]
  },
  {
    'name': 'Planner',
    'parent': 'SStudio',
    'resources': [
      'studio-models:read',
      'bookings:read',
      'bookings:write',
      'bookings:fast-track',
      'my-rates:read',
      'my-availabilities:write',
      'activities:read',
      'activities:write',
      'callsheets:read',
      'callsheets:send',
      'my-profile:read',
      'dashboard:read',
      'po-pre-approved:read'
    ]
  },
  {
    'name': 'Contributor',
    'parent': 'SStudio',
    'resources': [
      'my-rates:read',
      'my-availabilities:write',
      'activities:read',
      'my-profile:read',
      'callsheets:read',
    ]
  },
  {
    'name': 'ContentTeamManager',
    'parent': 'SStudio',
    'resources': [
      'carryover:write',
      'callsheets:read',
    ]
  },
  {
    'name': 'Stylist',
    'parent': 'SStudio',
    'resources': [
      'closet:read',
      'my-rates:read',
      'my-availabilities:write',
      'activities:read',
      'my-profile:read',
      'callsheets:read',
    ]
  }
]

export const allResources = [
  {
    'name': 'employees:read',
    'entity': 'employees',
    'operation': 'read',
    'description': 'Can see all Employees'
  },
  {
    'name': 'employees:write',
    'entity': 'employees',
    'operation': 'write',
    'description': 'Can edit and save any employee'
  },
  {
    'name': 'employees-rates:read',
    'entity': 'employees-rates',
    'operation': 'read',
    'description': 'Can see "Rates" section in any employee profile'
  },
  {
    'name': 'my-rates:read',
    'entity': 'my-rates',
    'operation': 'read',
    'description': 'Can see "Rates" section in my own employee profile'
  },
  {
    'name': 'my-availabilities:write',
    'entity': 'my-availabilities',
    'operation': 'write',
    'description': 'Can edit my own availability'
  },
  {
    'name': 'activities:read',
    'entity': 'activities',
    'operation': 'read',
    'description': 'Can see the activities in the Ecomm Pages'
  },
  {
    'name': 'activities:write',
    'entity': 'activities',
    'operation': 'write',
    'description': 'Can edit any activity in the Ecomm Pages'
  },
  {
    'name': 'callsheets:read',
    'entity': 'callsheets',
    'operation': 'read',
    'description': 'Can see Call Sheet view and read Call Sheet data'
  },
  {
    'name': 'callsheets:send',
    'entity': 'callsheets',
    'operation': 'send',
    'description': 'Can use the "Send out callsheets" button'
  },
  {
    'name': 'studio-models:read',
    'entity': 'studio-models',
    'operation': 'read',
    'description': 'Can see only m/f models, m/f fit models, and hmu artists'
  },
  {
    'name': 'bookings:read',
    'entity': 'bookings',
    'operation': 'read',
    'description': 'Can see all bookings'
  },
  {
    'name': 'bookings:write',
    'entity': 'bookings',
    'operation': 'write',
    'description': 'Can edit and save any booking'
  },
  {
    'name': 'bookings:fast-track',
    'entity': 'bookings',
    'operation': 'fast-track',
    'description': 'Can bypass booking confirmation'
  },
  {
    'name': 'last-minute-availabilities:write',
    'entity': 'last-minute-availabilities',
    'operation': 'write',
    'description': 'Can edit availabilities even if it is within the next 7 days'
  },
  {
    'name': 'reporting:read',
    'entity': 'reporting',
    'operation': 'read',
    'description': 'Can see Reporting View and read Reporting data'
  },
  {
    'name': 'entities:read',
    'entity': 'entities',
    'operation': 'read',
    'description': 'Can see all entities (entity manager)'
  },
  {
    'name': 'entities:write',
    'entity': 'entities',
    'operation': 'write',
    'description': 'Can edit and save any entity (entity manager)'
  },
  {
    'name': 'my-profile:read',
    'entity': 'my-profile',
    'operation': 'read',
    'description': 'Can see my own employee profile page'
  },
  {
    'name': 'dashboard:read',
    'entity': 'dashboard',
    'operation': 'read',
    'description': 'Can see the dashboard'
  },
  {
    'name': 'carryover:write',
    'entity': 'carryover',
    'operation': 'write',
    'description': 'Can merge old/new sku pairs'
  },
  {
    'name': 'closet:read',
    'entity': 'closet',
    'operation': 'read',
    'description': 'Can access the closet page'
  },
  {
    'name': 'po-pre-approved:read',
    'entity': 'po-pre-approved',
    'operation': 'read',
    'description': 'Can see PO pre-approved status'
  },
  {
    'name': 'po-pre-approved:write',
    'entity': 'po-pre-approved',
    'operation': 'write',
    'description': 'Can edit PO pre-approved status'
  }
];
